import { render, staticRenderFns } from "./addPlatform.vue?vue&type=template&id=45137d60&scoped=true"
import script from "./addPlatform.vue?vue&type=script&lang=js"
export * from "./addPlatform.vue?vue&type=script&lang=js"
import style0 from "./addPlatform.vue?vue&type=style&index=0&id=45137d60&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45137d60",
  null
  
)

export default component.exports